<template>
    <div class="text-sm bg-center bg-cover rounded-full cursor-pointer bg-neutral-200 w-8 h-8 lg:h-10 lg:w-10 text-center items-center flex justify-center">
        <i
            class="fa-solid text-lg"
            :class="icon"
        ></i>
    </div>
</template>

<script lang="ts" setup>
    import { MeilisearchContactEmailBadgeAttributes } from './EmailBadge.vue';
    import { CONTACT_TYPE } from '~/app/contact/enums/ContactType';

    const props = defineProps<{
        meilisearchContact: MeilisearchContactEmailBadgeAttributes;
    }>();

    const icon = computed(() => {
        switch (props.meilisearchContact.contact_type) {
            case CONTACT_TYPE.SUPPLIER:
                return 'fa-building-memo';
            case CONTACT_TYPE.CLIENT:
                return ' fa-user-check';
            default:
                return 'fa-user';
        }
    });
</script>

<style></style>
